const login = {
  termsOfService: "https://www.notion.so/16613e6cb495423f817ce6e683c3c5a2",
  privacyPolicy: "https://www.notion.so/ae9b80575db64e14aa9882adc85a553e",
};
const links = {
  login,
};

export default links;
